export function sheet_rows_to_xlsx(sheet_rows = []) {
  const sheet_xml = worksheet_xml(sheet_rows);
  return zip_files([
    ['[Content_Types].xml', content_types_xml()],
    ['_rels/.rels', root_rels_xml()],
    ['xl/workbook.xml', workbook_markup()],
    ['xl/_rels/workbook.xml.rels', workbook_rels_xml()],
    ['xl/styles.xml', styles_xml()],
    ['xl/worksheets/sheet1.xml', sheet_xml],
  ]);
}

function worksheet_xml(rows = []) {
  const row_xml = rows.map((row, row_index) =>
    `<row r="${row_index + 1}">${row_cells(row).map((value, column_index) =>
      `<c r="${cell_ref(column_index, row_index)}" t="inlineStr"${cell_style(row)}><is><t>${xml_escape(value)}</t></is></c>`
    ).join('')}</row>`
  ).join('');
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><sheetViews><sheetView workbookViewId="0"><pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews><sheetData>${row_xml}</sheetData></worksheet>`;
}

function row_cells(row = {}) {
  return Array.isArray(row) ? row : row.cells || [];
}

function cell_style(row = {}) {
  const styles = new Map([['header', 1], ['title', 2], ['section', 3], ['subsection', 4]]);
  const style = Array.isArray(row) ? 0 : styles.get(row.style) || 0;
  return style ? ` s="${style}"` : '';
}

function content_types_xml() {
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/></Types>';
}

function root_rels_xml() {
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>';
}

function workbook_markup() {
  const sheet_name = xml_escape('Report');
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets><sheet name="${sheet_name}" sheetId="1" r:id="rId1"/></sheets></workbook>`;
}

function workbook_rels_xml() {
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>';
}

function styles_xml() {
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><fonts count="4"><font><sz val="11"/><color theme="1"/><name val="Calibri"/></font><font><b/><sz val="11"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font><font><b/><sz val="16"/><color theme="1"/><name val="Calibri"/></font><font><b/><sz val="12"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font></fonts><fills count="5"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FF0C5144"/><bgColor indexed="64"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FF198754"/><bgColor indexed="64"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFEAF6F1"/><bgColor indexed="64"/></patternFill></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="5"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/><xf numFmtId="0" fontId="2" fillId="0" borderId="0" xfId="0" applyFont="1"/><xf numFmtId="0" fontId="3" fillId="3" borderId="0" xfId="0" applyFont="1" applyFill="1"/><xf numFmtId="0" fontId="0" fillId="4" borderId="0" xfId="0" applyFill="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>';
}

function zip_files(files = []) {
  const encoder = new TextEncoder();
  const local_parts = [];
  const central_parts = [];
  let offset = 0;

  files.forEach(([name, content]) => {
    const name_bytes = encoder.encode(name);
    const data = encoder.encode(content);
    const crc = crc32(data);
    const local = zip_local_header(name_bytes, data, crc);
    const central = zip_central_header(name_bytes, data, crc, offset);

    local_parts.push(local, data);
    central_parts.push(central);
    offset += local.length + data.length;
  });

  const central_size = central_parts.reduce((sum, part) => sum + part.length, 0);
  return new Blob([...local_parts, ...central_parts, zip_end_record(files.length, central_size, offset)]);
}

function zip_local_header(name_bytes, data, crc) {
  const header = new Uint8Array(30);
  const view = new DataView(header.buffer);
  write_uint32(view, 0, 0x04034b50);
  write_uint16(view, 4, 20);
  write_uint16(view, 8, 0);
  write_uint32(view, 14, crc);
  write_uint32(view, 18, data.length);
  write_uint32(view, 22, data.length);
  write_uint16(view, 26, name_bytes.length);
  return append_bytes(header, name_bytes);
}

function zip_central_header(name_bytes, data, crc, offset) {
  const header = new Uint8Array(46);
  const view = new DataView(header.buffer);
  write_uint32(view, 0, 0x02014b50);
  write_uint16(view, 4, 20);
  write_uint16(view, 6, 20);
  write_uint32(view, 16, crc);
  write_uint32(view, 20, data.length);
  write_uint32(view, 24, data.length);
  write_uint16(view, 28, name_bytes.length);
  write_uint32(view, 42, offset);
  return append_bytes(header, name_bytes);
}

function zip_end_record(count, central_size, central_offset) {
  const record = new Uint8Array(22);
  const view = new DataView(record.buffer);
  write_uint32(view, 0, 0x06054b50);
  write_uint16(view, 8, count);
  write_uint16(view, 10, count);
  write_uint32(view, 12, central_size);
  write_uint32(view, 16, central_offset);
  return record;
}

function write_uint16(view, offset, value) {
  view.setUint16(offset, value, true);
}

function write_uint32(view, offset, value) {
  view.setUint32(offset, value, true);
}

function append_bytes(prefix, suffix) {
  return Uint8Array.from([...prefix, ...suffix]);
}

function crc32(data) {
  let crc = -1;
  data.forEach((byte) => {
    crc = (crc >>> 8) ^ crc_table_value((crc ^ byte) & 0xff);
  });
  return (crc ^ -1) >>> 0;
}

function crc_table_value(index) {
  if (!Number.isInteger(index) || index < 0 || index > 255) return 0;
  let value = index;
  for (let bit = 0; bit < 8; bit += 1) {
    value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
  }
  return value >>> 0;
}

function cell_ref(column_index, row_index) {
  let index = column_index + 1;
  let column = '';
  while (index > 0) {
    const remainder = (index - 1) % 26;
    column = `${String.fromCharCode(65 + remainder)}${column}`;
    index = Math.floor((index - 1) / 26);
  }
  return `${column}${row_index + 1}`;
}

function xml_escape(value = '') {
  const entities = new Map([
    ['<', '&lt;'],
    ['>', '&gt;'],
    ['&', '&amp;'],
    ["'", '&apos;'],
    ['"', '&quot;'],
  ]);
  return String(value ?? '').replace(/[<>&'"]/g, (char) => entities.get(char) || char);
}
